import type { PackageFilterCriteriaOA } from '@openx/types/package.ts';
import {
  type CriteriaChange,
  CriteriaDimension,
  type SortCriteria,
  SortDirection,
} from '@openx/types/tableCriteria.ts';
import { applyCriteriaChange } from '@openx/utils/lib/tableCriteria.ts';
import isEqual from 'lodash/isEqual';
import type { Dispatch, SetStateAction } from 'react';

import { defaultCriteria } from '../constants.ts';

type CriteriaChangeHandlerProps = {
  criteria: PackageFilterCriteriaOA;
  newCriteria: CriteriaChange<CriteriaDimension, Record<string, unknown>>;
  setCriteria: Dispatch<SetStateAction<PackageFilterCriteriaOA>>;
};

export const criteriaChangeHandler = ({ criteria, newCriteria, setCriteria }: CriteriaChangeHandlerProps) => {
  const isSort = newCriteria?.dimension === CriteriaDimension.SORT;
  const sortValue = isSort ? (newCriteria.value as SortCriteria) : null;

  if (
    sortValue &&
    sortValue.column === criteria.sort?.column &&
    sortValue.direction === SortDirection.ASC &&
    sortValue.column !== defaultCriteria.sort?.column
  ) {
    sortValue.column = defaultCriteria.sort?.column ?? '';
    sortValue.direction = defaultCriteria.sort?.direction ?? SortDirection.DESC;
  }

  let newCriteriaAdjusted: CriteriaChange<CriteriaDimension, Record<string, unknown>> = { ...newCriteria };

  if (newCriteria.dimension !== CriteriaDimension.PAGINATION && newCriteria.dimension !== CriteriaDimension.SORT) {
    newCriteriaAdjusted = { dimension: CriteriaDimension.FILTERS, value: newCriteria.value };
  }

  const newCriteriaProcessed = applyCriteriaChange(criteria, newCriteriaAdjusted);

  if (!isEqual({ ...newCriteriaProcessed }, { ...criteria })) {
    setCriteria(newCriteriaProcessed as PackageFilterCriteriaOA);
  }
};
